import { render, staticRenderFns } from "./FullScreenLoading.vue?vue&type=template&id=6b84150d&scoped=true&"
import script from "./FullScreenLoading.vue?vue&type=script&lang=js&"
export * from "./FullScreenLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84150d",
  null
  
)

export default component.exports